import { render, staticRenderFns } from "./FormChoiceLabel.vue?vue&type=template&id=c86d8c3a"
import script from "./FormChoiceLabel.vue?vue&type=script&lang=js"
export * from "./FormChoiceLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports